import { render, staticRenderFns } from "./Diabetes.vue?vue&type=template&id=4d94271b&"
import script from "./Diabetes.vue?vue&type=script&lang=js&"
export * from "./Diabetes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports